import React from 'react'
import { getLeadName } from '../../Config/leadStatus';
import { getDateFormat } from '../../Config/functions';

export const EhcInformation = ({props,status}:any) => {
    const {date,time,expert,lead_owner,notes,ehc_followup_notes} = props;
    return (
        <div className="col-sm-6 px-4">
            <h4>EHC Information</h4>
            <table className="table table-striped border-0 mt-4">
                <tbody>
                    <tr>
                        <th scope="row">Date:</th>
                        <td>{date ?getDateFormat(date): ''}</td>
                    </tr>
                    <tr>
                        <th scope="row">Time (24H Format)</th>
                        <td>{time}</td>
                    </tr>
                    <tr>
                        <th scope="row">EHC Expert:</th>
                        <td>{expert}</td>
                    </tr>
                    <tr>
                        <th scope="row">Lead Status</th>
                        <td>{getLeadName(status)}</td>
                    </tr>
                    <tr>
                        <th scope="row">Notes:</th>
                        <td colSpan={3}>{notes}</td>
                    </tr>
                    <tr>
                        <th scope="row">EHC Followup Notes</th>
                        <td colSpan={3}>{ehc_followup_notes}</td>

                    </tr>
                </tbody>
            </table>
        </div>
    )
}
